module.exports = __webpack_public_path__ + "img/P150T_weapon_21.10c7397a.png";